import { memo } from 'react';
import SimpleModelResponseSelectorTaskComponent from './SimpleModelResponseSelectorTaskComponent';
import { StepViewComponentProps } from '../stepDescriptor/types';

const ModelResposeSelectorPinnedViewComponent = ({
  responseIndex,
  readOnly,
  complete,
}: StepViewComponentProps) => {
  return (
    <SimpleModelResponseSelectorTaskComponent
      responseIndex={responseIndex}
      complete={complete}
      readOnly={readOnly}
      isPinnable
      isPinnedView
    />
  );
};

export default memo(ModelResposeSelectorPinnedViewComponent);
